// Het bord verhuist naar een nieuw adres (oprichter 28 sep 2026: board.amumin.app;
// apps/kiosk/src/device/handoff.ts). Rustig en kort: het bord blijft gekoppeld, er gaat niets
// verloren. {host} = het nieuwe adres zonder https:// ("board.amumin.app").
export const kioskMoveNl = {
    title: 'Het bord verhuist',
    body: 'Het gezinsbord heeft een nieuw adres: {host}. Het gaat er nu vanzelf heen en blijft gekoppeld.',
    askBody: 'Het gezinsbord heeft een nieuw adres: {host}. Tik op Verder: Safari opent het bord daar, nog steeds gekoppeld. Daarna leggen we uit hoe je het opnieuw op het beginscherm zet.',
    askBodyUnpaired: 'Het gezinsbord heeft een nieuw adres: {host}. Tik op Verder om het daar te openen en te koppelen.',
    button: 'Verder',
    later: 'Later',
    failed: 'Verhuizen lukt nu even niet. Het bord probeert het straks opnieuw.',
    homeTitle: 'Zet het bord opnieuw op het beginscherm',
    homeBody: 'Het bord staat nu op {host}. Tik in Safari op Delen en dan op "Zet op beginscherm". Open het bord daarna meteen via het nieuwe icoon en verwijder het oude icoon. Vraagt het nieuwe icoon om een code, koppel het dan opnieuw in de app. Sluit daarna deze uitleg in Safari.',
    invalid: 'Deze verhuiscode is verlopen of al gebruikt. Koppel het bord opnieuw met de code op dit scherm.',
    offline: 'Geen verbinding, dus het verhuizen lukte niet. Koppel het bord opnieuw met de code op dit scherm.',
    /** De ouderapp heeft deze tablet losgekoppeld (koppelscherm). */
    revoked: 'Losgekoppeld in de ouderapp.',
};
//# sourceMappingURL=kioskMove.nl.js.map